module.exports = __webpack_public_path__ + "img/CR02EN.917fa25e.png";